import React from 'react'
import Footer from '../Components/Footer/Footer'
import Forgot from '../Components/ForgotPass/FormForgot'

export default function ForgotPassword() {
  return (
    <div>
      <Forgot/>
      <Footer/>
    </div>
  )
}
